import React from "react";

import Table from "./table";

const TableContainer = () => <Table />;

export default TableContainer;
